import { FETCH_TAGS, SET_TAGS_DATA } from "./actionTypes";

export const fetchTagsData = () => {
  return { type: FETCH_TAGS };
};

export const setTagsData = (data: any) => {
  return { type: SET_TAGS_DATA, payload: data };
};
